import { countryName } from '@shared/countries';
import type { BillingAddress } from './types';

/** Keep receipt names separate from workspace names; GST belongs to India only. */
export function normalizeBillingAddress(address: BillingAddress): BillingAddress {
  const country = countryName(address.country) ?? '';
  const gstNumber = country === 'India' ? address.gst_number.trim().toUpperCase() : '';
  return {
    ...address,
    country,
    address: address.address.trim(),
    city: address.city.trim(),
    state: address.state.trim(),
    zip_code: address.zip_code.trim(),
    billing_name: (address.billing_name ?? '').trim(),
    gst_number: gstNumber,
    gst_org_name: gstNumber ? (address.gst_org_name ?? '').trim() : '',
  };
}
